import { translate } from '@jsverse/transloco';
export enum ReferenceTaskType {
    DOCUMENT = 'DOCUMENT',
    TEXT = 'TEXT',
    DATE = 'DATE',
    SINGLE_SELECT = 'SINGLE_SELECT',
    MULTI_SELECT = 'MULTI_SELECT',
    TODO = 'TODO',
    NO_RESPONSE = 'NO_RESPONSE',
}

export class ReferenceTaskTypeHelper {
    static getReferenceTaskLocale(type: ReferenceTaskType) {
        switch (type) {
            case ReferenceTaskType.DOCUMENT:
                return translate('CORE.REFERENCE_TASK_TYPES.DOCUMENT');
            case ReferenceTaskType.DATE:
                return translate('COMMON_UI.DATE');
            case ReferenceTaskType.TEXT:
                return translate('CORE.REFERENCE_TASK_TYPES.TEXT');
            case ReferenceTaskType.SINGLE_SELECT:
                return translate('CORE.REFERENCE_TASK_TYPES.SINGLE_SELECT');
            case ReferenceTaskType.MULTI_SELECT:
                return translate('CORE.REFERENCE_TASK_TYPES.MULTI_SELECT');
            case ReferenceTaskType.TODO:
                return translate('CORE.REFERENCE_TASK_TYPES.TODO');
            case ReferenceTaskType.NO_RESPONSE:
                return translate('CORE.REFERENCE_TASK_TYPES.NO_RESPONSE');
            default:
                return type;
        }
    }
}
